import React from "react";
import { Grid } from "@mui/material";
import PageHeader from "../Layout/Header/PageHeader";
import HomepageCard from "./HomepageCard";
import CarrierImage from "./HomepageImages/carrier_16-9.png";
import LocationImage from "./HomepageImages/location_16-9.png";
import ContactImage from "./HomepageImages/contact_16-9.png";
import ProjectImage from "./HomepageImages/project_16-9.png";
import BidpackImage from "./HomepageImages/bidpack_16-9.png";
import TransportNetworkImage from "./HomepageImages/transport-network_16-9.png";
import RoutesImage from "./HomepageImages/trip-data_16-9.png";
import ValidationImage from "./HomepageImages/validation_16-9.png";
import HomepageCardWithButtons from "./HompageCardWithButtons";

export function HomePage() {
  const containerStyle = {};
  return (
    <>
      <PageHeader headerText="Home" />
      <Grid container columnSpacing={3} rowSpacing={4} style={containerStyle}>
        <Grid item sm={12} md={6} lg={4} xl={3}>
          <HomepageCard
            route="/Carriers"
            image={CarrierImage}
            title="FORD LLP I2M"
            text="Carrier"
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4} xl={3}>
          <HomepageCardWithButtons
            image={LocationImage}
            title="FORD LLP I2M"
            text="Location"
            buttons={[
              { text: "Supplier", route: "/Suppliers" },
              { text: "Plant", route: "/Plants" },
              { text: "EDC", route: "/EDCs" },
              { text: "ODC & Other", route: "/ODCs" },
            ]}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4} xl={3}>
          <HomepageCard
            route="/Contacts"
            image={ContactImage}
            title="FORD LLP I2M"
            text="Contact"
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4} xl={3}>
          <HomepageCardWithButtons
            image={BidpackImage}
            title="FORD LLP I2M"
            text="Bid Pack & Rate Agrmt."
            buttons={[
              { text: "Bid Pack", route: "/BidPacks" },
              { text: "Rate Agreement", route: "/RateAgreements" },
            ]}
          />
        </Grid>

        <Grid item sm={12} md={6} lg={4} xl={3}>
          <HomepageCardWithButtons
            image={TransportNetworkImage}
            title="FORD LLP I2M"
            text="Transport Network"
            buttons={[
              { text: "Inbound", route: "/SPDRs" },
              { text: "Return", route: "/ReturnNetwork" },
              { text: "TT Protection", route: "/TTProtections" },
            ]}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4} xl={3}>
          <HomepageCardWithButtons
            image={RoutesImage}
            title="FORD LLP I2M"
            text="Route Data"
            buttons={[
              { text: "FTL Routes", route: "/FTLRoutes" },
              { text: "Proposed FTL Routes", route: "/ProposedFTLRoutes" },
            ]}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4} xl={3}>
          <HomepageCard
            route="/Projects"
            image={ProjectImage}
            title="FORD LLP I2M"
            text="Project"
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4} xl={3}>
          <HomepageCardWithButtons
            image={ValidationImage}
            title="FORD LLP I2M"
            text="Validation Backlog"
            buttons={[{ text: "PDSR Validation", route: "/PDSRs" }]}
          />
        </Grid>
      </Grid>
    </>
  );
}
